'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '@/stores/authStore';

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const utente = useAuthStore((s) => s.utente);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!utente || !token) {
      router.push('/login');
    }
  }, [utente, router]);

  const token = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null;
  if (!utente || !token) return null;

  return <>{children}</>;
}
